import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'

import * as jzjyModule from './jzjy/index';

Vue.use(Vuex)

const strict = process.env.NODE_ENV !== 'production'

let modules = Object.assign({}, jzjyModule);

const store = new Vuex.Store({
  modules,
  plugins: [createLogger()],
  strict
})

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js